module.exports = __webpack_public_path__ + "media/images/front/event/event-icon-b18345d12262ff05d4474c48d5d8f083.svg";